
class AppConstants {     
   FILE_TYPE_TEXT_PLAIN = "text/plain";
   FILE_TYPE_CSV_v1 = "text/csv";//for IE
   FILE_TYPE_CSV_v2 ="application/vnd.ms-excel";//for chrome
}

const APP_CONST = new AppConstants()

export default APP_CONST;